import { Document } from '@contentful/rich-text-types';
import { config } from '@brand';
import { readableKey } from './microcopy-fallback';
export interface MicrocopyResource {
  key: string,
  value: string | Document
}

export interface HelpIconInterface {
  sys: { id: string },
  modalTitle: string;
  modalContent: { json: Document };
}

export interface ContentfulModalContent {
  fields: {
    buttonText: string;
    modalTitle: string;
    modalContent: Document
    url?: string
  }
}

const serverName = process.env.NODE_ENV !== 'production' ? 'http://localhost:3000' : config.selfUrl;

export class Microcopy {
  public getFromKey(keyArg: string, microObj: { key: string, value: Document | string }[]) {
    const findKey = microObj.find(x => x.key === keyArg);

    if (findKey) {
      return findKey.value as string;
    } else {
      return readableKey(keyArg);
    }
  }

  public getRichContentFromKey(keyArg: string, microObj: { key: string, richContent: RichContent }[]) {
    const findKey = microObj.find(x => x.key === keyArg);

    if (findKey) {
      return findKey.richContent;
    } else {
      return keyArg;
    }
  }

  public async fetch(setId: string): Promise<any> {
    return await fetch(`${serverName}/api/microcopy?id=${setId}`).then(res => res.json());
  }
}

export class ContentfulHelpIcons {
  public async fetch(): Promise<any> {
    return await fetch(`${serverName}/api/help-icons`).then(res => res.json());
  }
}

export class Content {
  public async fetch(contentId: string): Promise<any> {
    return await fetch(`${serverName}/api/content?id=${contentId}`).then(res => res.json());
  }
}

export class Partner {
  public async resolve(key: string): Promise<PartnerResolution> {
    return await fetch(`${serverName}/api/partner?id=${encodeURIComponent(key)}`).then(res => res.json());
  }

  public async list(): Promise<{ partners: ContentfulPartner[] }> {
    const origin = typeof window === 'undefined' ? serverName : '';

    return await fetch(`${origin}/api/partners`).then(res => res.json());
  }
}
